module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/tee/8-d90ba6e9e0a4332c23135970f06a311d.jpg";